// extracted by mini-css-extract-plugin
export default {"button-wrap":"AddNewMedicineForm_button-wrap__kEy+8","quit":"AddNewMedicineForm_quit__i0Axy"};